import type { RouteRecordRaw } from "vue-router"

export const TestRoutes: RouteRecordRaw[] = [
  {
    name: "test.routes",
    path: "",
    components: {
      layout: () => import("@/components/layout/PlainLayout.vue"),
    },
    children: [
      {
        name: "load-test-case",
        path: "/test/case/:id",
        component: () => import("./TestCaseLoadPage.vue"),
        props: true,
      },
    ],
  },
]
